import { render, staticRenderFns } from "./discus-1.vue?vue&type=template&id=3084e8d1&scoped=true&"
import script from "./discus-1.vue?vue&type=script&lang=js&"
export * from "./discus-1.vue?vue&type=script&lang=js&"
import style0 from "./discus-1.vue?vue&type=style&index=0&id=3084e8d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084e8d1",
  null
  
)

export default component.exports